import { SharedState } from '$utils/sharedState.svelte';

class StateNavigation extends SharedState<Array<string>> {
  get last() {
    return this.current ? this.current.slice(-1)[0] : null;
  }

  public removeItem(item: string) {
    if (this.current) {
      const index = this.current.indexOf(item);
      if (index !== -1) {
        this.current.splice(index, 1);
      }
    }
  }
}

export const stateNavigation = new StateNavigation([]);
